export default {
  showGradient: true,
};
